/* @flow */
import { validation } from '../FAQ3.consts'
import { simpleButtonActionMaker } from '@website/components/ActionMakers'
import {
  changeTitle,
  changeParagraph,
  changeTitleAlignment,
  changeParagraphAlignment
} from '@website/components/CommonActions'
import DeleteIcon from '@editor/common/assets/svgr-icons/Delete_icon_2.svg'
import { translate } from '@editor/common/utils/translations'

export default dispatch => {
  const changeQuestion = (newQuestion: string, idx: number) => ({
    type: 'CHANGE_QUESTION',
    value: { newQuestion, idx }
  })

  const changeAnswer = (newAnswer: string, idx: number) => ({
    type: 'CHANGE_ANSWER',
    value: { newAnswer, idx }
  })

  const removeFaq = (idx: number) => ({
    type: 'REMOVE_FAQ',
    value: idx
  })

  const _changeTitle = newTitle => {
    dispatch(changeTitle(newTitle))
  }

  const _changeParagraph = newParagraph => {
    dispatch(changeParagraph(newParagraph))
  }

  const _changeQuestion = (newQuestion, idx) => {
    dispatch(changeQuestion(newQuestion, idx))
  }

  const _changeAnswer = (newAnswer, idx) => {
    dispatch(changeAnswer(newAnswer, idx))
  }

  const _changeTitleAlignment = alignment => {
    dispatch(changeTitleAlignment(alignment))
  }

  const _changeParagraphAlignment = alignment => {
    dispatch(changeParagraphAlignment(alignment))
  }

  const changeBlockTitleAlignment = (alignment: string, idx: number) => {
    dispatcher({
      type: 'CHANGE_BLOCK_TITLE_ALIGNMENT',
      value: { alignment, idx }
    })
  }

  const changeBlockParagraphAlignment = (alignment: string, idx: number) => {
    dispatcher({
      type: 'CHANGE_BLOCK_PARAGRAPH_ALIGNMENT',
      value: { alignment, idx }
    })
  }

  return {
    changeTitle: _changeTitle,
    changeParagraph: _changeParagraph,
    changeQuestion: _changeQuestion,
    changeAnswer: _changeAnswer,
    changeTitleAlignment: _changeTitleAlignment,
    changeParagraphAlignment: _changeParagraphAlignment,
    changeBlockTitleAlignment,
    changeBlockParagraphAlignment,
    addFaq: () => dispatch({ type: 'ADD_FAQ' }),
    faqActions: (idx: number, faqCount: number) => [
      {
        IconComp: DeleteIcon,
        tooltipText: translate('delete_label'),
        handler: () => dispatch(removeFaq(idx)),
        toShow: faqCount > validation.faqs.min
      }
    ]
  }
}
